import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="relative min-h-screen flex items-center pt-32 pb-24 overflow-hidden bg-white" data-id="element-184">
      <div className="container mx-auto px-6 md:px-12 grid md:grid-cols-2 gap-12 md:gap-16 items-center" data-id="element-185">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="max-w-xl z-10 flex flex-col" data-id="element-186">
          <h1 className="order-1 font-heading text-5xl md:text-6xl lg:text-7xl font-semibold leading-tight tracking-tight text-ink mb-8 md:mb-6" data-id="element-187">
            Бездоганний стиль, <br data-id="element-188" />
            що підкреслює вашу красу
          </h1>

          {/* Mobile Image */}
          <div className="order-2 md:hidden relative h-[400px] sm:h-[500px] w-full mb-10 group" data-id="element-189">
            <div className="absolute inset-0 bg-surface rounded-[2rem] overflow-hidden flex items-center justify-center border border-line shadow-xl" data-id="element-190">
              <div className="text-center" data-id="element-191">
                <div className="w-14 h-14 mx-auto mb-3 border border-line rounded-full flex items-center justify-center bg-white shadow-sm" data-id="element-192">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="text-muted" data-id="element-193">
                    <rect x="3" y="3" width="18" height="18" rx="2" ry="2" data-id="element-194"></rect>
                    <circle cx="8.5" cy="8.5" r="1.5" data-id="element-195"></circle>
                    <polyline points="21 15 16 10 5 21" data-id="element-196"></polyline>
                  </svg>
                </div>
                <p className="text-xs text-muted font-medium tracking-widest uppercase" data-id="element-197">
                  Місце для фото
                </p>
              </div>
            </div>
          </div>

          <div className="order-3" data-id="element-198">
            <p className="text-muted text-lg md:text-xl mb-10 font-normal leading-relaxed" data-id="element-199">
              Повний спектр послуг: від стрижок та складного фарбування до
              манікюру та догляду.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-16" data-id="element-200">
              <a href="#contact" className="px-8 py-4 bg-ink text-white text-center text-sm font-medium tracking-wide rounded-full hover:bg-black transition-all duration-300 shadow-lg hover:shadow-xl" data-id="element-201">
                Записатися на послугу
              </a>
              <a href="#courses" className="px-8 py-4 border border-line text-ink text-center text-sm font-medium tracking-wide rounded-full hover:bg-surface transition-all duration-300" data-id="element-202">
                Дізнатися про курси
              </a>
            </div>

            <div className="grid grid-cols-3 gap-4 sm:gap-6 border-t border-line pt-8" data-id="element-203">
              <div data-id="element-204">
                <p className="font-heading text-3xl sm:text-4xl font-semibold text-ink mb-1" data-id="element-205">
                  12+
                </p>
                <p className="text-[10px] sm:text-xs text-muted uppercase tracking-wider font-medium" data-id="element-206">
                  Років досвіду
                </p>
              </div>
              <div data-id="element-207">
                <p className="font-heading text-3xl sm:text-4xl font-semibold text-ink mb-1" data-id="element-208">
                  5k+
                </p>
                <p className="text-[10px] sm:text-xs text-muted uppercase tracking-wider font-medium" data-id="element-209">
                  Задоволених клієнтів
                </p>
              </div>
              <div data-id="element-210">
                <p className="font-heading text-3xl sm:text-4xl font-semibold text-ink mb-1" data-id="element-211">
                  300+
                </p>
                <p className="text-[10px] sm:text-xs text-muted uppercase tracking-wider font-medium" data-id="element-212">
                  Випускників курсів
                </p>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Desktop Image */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.2,
        ease: 'easeOut'
      }} className="hidden md:block relative h-[600px] lg:h-[800px] w-full group" data-id="element-213">
          <div className="absolute inset-0 bg-surface rounded-[2.5rem] overflow-hidden flex items-center justify-center border border-line shadow-2xl transition-transform duration-700 ease-out group-hover:scale-[1.02]" data-id="element-214">
            <div className="text-center" data-id="element-215">
              <div className="w-16 h-16 mx-auto mb-4 border border-line rounded-full flex items-center justify-center bg-white shadow-sm" data-id="element-216">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="text-muted" data-id="element-217">
                  <rect x="3" y="3" width="18" height="18" rx="2" ry="2" data-id="element-218"></rect>
                  <circle cx="8.5" cy="8.5" r="1.5" data-id="element-219"></circle>
                  <polyline points="21 15 16 10 5 21" data-id="element-220"></polyline>
                </svg>
              </div>
              <p className="text-sm text-muted font-medium tracking-widest uppercase" data-id="element-221">
                Місце для фото
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}